import { render, staticRenderFns } from "./BlockTeacher.vue?vue&type=template&id=48a8d3f8&"
import script from "./BlockTeacher.vue?vue&type=script&lang=js&"
export * from "./BlockTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports